export const operatorStatusLabels = {
  'null': 'Sem status',
  refused_by_operator: 'Recusado pelo operador',
  approved: 'Aprovado',
  received_externally: 'Recebida fora da plataforma',
} as const

export type OperatorStatus = keyof typeof operatorStatusLabels;
